import React, { useMemo } from "react";
import { Decimal } from "decimal.js";

import MaterialProgress from "components/MaterialProgress/MaterialProgress";
import { PlantItem, PlantContent } from "components/StyledComponents";

import MultipleProgressSubscriptionWrapper from "./MultipleProgressSubscriptionWrapper";

// The sum is derived straight from the props: each item's subscription patches its
// quantity into the PLANT_LOCATIONS cache entry, so what arrives here is already
// the live value. This used to be a local copy of the items, seeded once and then
// patched through an onSubscriptionData callback — which meant the sum never
// picked up the resync after a websocket reconnect, and an event missed while the
// subscription was being recreated was lost for good.
const sumBy = (items, pick) => items.reduce(
  (total, item) => new Decimal(pick(item) || 0).plus(total),
  0,
);

const ProgressAggregate = ({
  concreteShipmentId,
  inventoryItems,
  numberOfColumns,
  isContainerVertical,
}) => {
  // Nothing to aggregate without a shipment, or before the formula has loaded:
  // the quantities would be added up against a total of zero.
  const items = useMemo(() => (
    concreteShipmentId && inventoryItems.some(({ shipmentMaterial }) => !!shipmentMaterial)
      ? inventoryItems
      : []
  ), [concreteShipmentId, inventoryItems]);

  const value = useMemo(
    () => sumBy(items, item => item.itemShipmentQuantity),
    [items],
  );

  const total = useMemo(
    () => sumBy(items, item => (item.shipmentMaterial ? item.shipmentMaterial.formulaWeight : 0)),
    [items],
  );

  return (
    <React.Fragment>
      <PlantContent
        cols={1}
        isContainerVertical={isContainerVertical}
      >
        <PlantItem className={isContainerVertical ? "" : "center-vertically"}>
          <MaterialProgress
            title="Soma"
            value={value}
            total={total}
          />
        </PlantItem>
      </PlantContent>

      <PlantContent
        cols={numberOfColumns}
        isContainerVertical={isContainerVertical}
      >
        <MultipleProgressSubscriptionWrapper
          concreteShipmentId={concreteShipmentId}
          inventoryItems={inventoryItems}
        />
      </PlantContent>
    </React.Fragment>
  );
};

export default ProgressAggregate;
